<template>
  <div id="app">
    <md-app md-waterfall>

      <!-- Toolbar -->
      <md-app-toolbar class="md-primary md-large"></md-app-toolbar>

      <md-app-content>

        <div class="md-layout content-with-hover">

          <div class="left-menu md-layout-item md-small-size-100 md-medium-size-25 md-large-size-20 md-xlarge-size-15">
            <!-- Profile -->
            <Profile :image=profile.image />
            <!-- Menu -->
            <Menu :name=profile.name :items=menu :social=social />
          </div>

          <!-- Website Content -->
          <div class="md-layout-item md-small-size-100 md-medium-size-75 md-large-size-80 md-xlarge-size-85">
            <router-view></router-view>
          </div>
        </div>
      </md-app-content>
    </md-app>
  </div>
</template>

<script>

import Profile from './components/Profile.vue'
import Menu from './components/Menu.vue'
import image from "./assets/fabricio.jpg"

export default {
  name: 'App',
  components: {
    Profile, Menu
  },
  data: function() {
    return {
      profile: {
        name: "Fabrício Ceschin",
        image: image,
        keywords: "Fabrício Ceschin fjoc12 fjoeschin"
        // image: "./img/fabricio.jpg"
      },
      // Menus
      menu: [
        { name: 'Home', path: "/", icon: "home"},
        { name: 'About', path: "/about", icon: "info"},
        { name: 'Projects', path: "/projects", icon: "work"},
        { name: 'Publications', path: "/publications", icon: "book"},
        { name: 'Contact', path: "/contact", icon: "chat"},
        { name: 'Random Stuff', path: "/randomstuff", icon: "help"}
      ],
      // Social Networks
      social: [
        { name: 'Facebook', url: 'https://www.facebook.com/fabricio.ceschin', icon: 'fab fa-facebook-f' },
        { name: 'Twitter', url: 'http://www.twitter.com/fabriciojoc', icon: 'fab fa-twitter' },
        { name: 'LinkedIn', url: 'http://br.linkedin.com/in/fabricioceschin', icon: 'fab fa-linkedin-in' },
        { name: 'Scholar', url: 'https://scholar.google.com/citations?user=73-lqdUAAAAJ&hl=pt-BR', icon: 'fas fa-graduation-cap' },
        { name: 'YouTube', url: 'https://www.youtube.com/c/Fabr%C3%ADcioCeschin', icon: 'fab fa-youtube' }
      ]
    }
  },
  head() {
    return {
      meta: [
        // For Google
        { name: "description", content: this.$i18n.t('description') },
        { name: "keywords", content: this.profile.keywords },
        { name: "author", content: this.profile.name },
        { name: "copyright", content: this.profile.name },
        { name: "application-name", content: this.profile.name },
        // For Facebook
        { property: "og:title", content: this.profile.name },
        { property: "og:image", content: "http://www.inf.ufpr.br/fjoceschin/favicon.png" },
        { property: "og:description", content: this.$i18n.t('description') },
        // For Twitter
        { name: "twitter:card", content: "summary" },
        { name: "twitter:title", content: this.profile.name },
        { name: "twitter:description", content: this.$i18n.t('description') },
        { name: "twitter:image", content: "http://www.inf.ufpr.br/fjoceschin/favicon.png" }
      ]
    }
  }
}
</script>

<style lang="scss">
  @import "~vue-material/dist/theme/engine"; // Import the theme engine

  @include md-register-theme("default", (
    primary: md-get-palette-color(blue, A200), // The primary color of your application
    accent: md-get-palette-color(blue, A200), // The accent or secondary color
    theme: dark // This can be dark or light
  ));

  @import "~vue-material/dist/theme/all"; // Apply the theme
</style>

<style>

/* small */
@media (max-width: 960px) {
  .left-menu, .left-profile {
    border-right: none !important;
  }

  .left-menu {
    border-right: 1px solid #383838;
  }

  .right-profile {
    background-color: #565656;
  }
}

.content {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.md-card {
  padding-bottom:0;
}

.left-menu {
  border-right: 1px solid #383838;
}

.left-menu,
.md-list.md-theme-default {
  background-color: #565656;
}

.md-card {
  padding-top:0;
  padding-left:0;
  padding-right:0;
}

.md-toolbar {
  background-image:url('./assets/bg.png');
  background-position:bottom;
  background-repeat: repeat-x;
}

.md-app .md-app-toolbar {
  z-index: 1;
}

.md-app .md-app-toolbar {
  min-height: 0;
}

.md-app .md-app-toolbar {
    height: 196px;
}

.md-app {
    transform: translateZ(0);
}

.md-app.md-theme-default {
  background:none !important;
}

.md-app .md-app-content {
    margin: -64px 24px 24px;
    position: relative;
    z-index: 2;
    padding: 0;
}

.router-link-active span{
  color: white;
}

.router-link-active {
  background-color:gray;
}

.content-with-hover {
  transition: background-color .3s cubic-bezier(.4,0,.2,1),box-shadow .4s cubic-bezier(.25,.8,.25,1);
  will-change: background-color,box-shadow;
}

.content-with-hover:hover {
  z-index: 2;
  box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);
}

</style>
